import create from 'zustand'

const range = 58;
const amt = 5;
const startY = 65;
const sphereSize = 1
const loopDur = 4

const useStore = create((set, get) => {
  return {
    amt,
    startY,
    sphereSize,
    loopDur,
    clicked: false,
    mut: {
      clicked: true,
      spheres: new Array(amt).fill().map((v, i) => ([-range*0.5 + i*(range/amt) + ((range/amt)/2) - 0.5, startY, 0.4])),
      downSphere: null,
      downBox: null,
    },
    set: (key, val) => set(() => {
      return { [key]: val };
    }),
  }
})

export default useStore
